module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-SemiboldItalic-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-SemiboldItalic-webfont.ttf
// module id = 367
// module chunks = 0